<template>
  <div style="width: 100%; height: 300px; position: relative">
    <canvas ref="ovationsBarChart"></canvas>
  </div>
</template>

<script>
export default {
  name: "OvationsBarChart",
  props: ["data"],
  mounted() {
    let chartData = {
      labels: [],
      datasets: [
        {
          label: "Added",
          backgroundColor: "#e21f4c",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
        {
          label: "Assigned",
          backgroundColor: "#3cc0c9",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
        {
          label: "Sent",
          backgroundColor: "#e0922f",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
        {
          label: "AutoAssigned",
          backgroundColor: "#1976D2",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
        {
          label: "Refunded",
          backgroundColor: "#7FDBFF",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
        {
          label: "Redeemed",
          backgroundColor: "#3D9970",
          maxBarThickness: 28,
          borderRadius: 20,
          borderSkipped: false,
          fill: true,
          data: [],
        },
      ],
    };

    for (
      let counter = 0, length = this.data.length;
      counter < length;
      counter++
    ) {
      chartData.labels.push(this.data[counter].month);
      chartData.datasets[0].data.push(this.data[counter].added);
      chartData.datasets[1].data.push(this.data[counter].assigned);
      chartData.datasets[2].data.push(this.data[counter].sent);
      chartData.datasets[3].data.push(this.data[counter].autoAssigned);
      chartData.datasets[4].data.push(this.data[counter].refunded);
      chartData.datasets[5].data.push(this.data[counter].redeemed);
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 10,
            usePointStyle: true,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    };

    let config = {
      type: "bar",
      data: chartData,
      options,
    };

    new Chart(this.$refs.ovationsBarChart, config);
  },
};
</script>
